import React from 'react';

import '@/utils';
import Root from '@/Root';
import {createRoot} from "react-dom/client";

const root = createRoot(document.getElementById("root"));
root.render(<Root />);

